import getLocalString from "constants/Localization";
import { useUpdateProposalDiscountMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateProposalDiscount() {
  const [mutation, { loading, data, error }] = useUpdateProposalDiscountMutation({
    refetchQueries: ["customGetProposal"],
  });
  const [updateProposalDiscount, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateProposalDiscount",
    },
    {
      successMessage: getLocalString("proposals.update-proposal-discount-success"),
      failureMessage: getLocalString("proposals.update-proposal-discount-failure"),
    }
  );

  return [updateProposalDiscount, context] as const;
}
